import { container, lazyInject } from "./container";
import { GAService } from "../services/analytics.service";
import { ApiConfig } from "../services/api-config";
import { AuthService } from "../services/auth.service";
import { ConnectivityService } from "../services/connectivity.service";
import { DOMStorage } from "../services/dom-storage.service";
import { DropboxService } from "../services/dropbox.service";
import { EnvironmentService } from "../services/environment.service";
import { FileDownloadService } from "../services/file-download.service";
import { FileInputButtonService } from "../services/file-input-button.service";
import { FileManagerService } from "../services/file-manager.service";
import { FileProcessService } from "../services/file-process.service";
import { FileShareService } from "../services/file-share.service";
import { FileUploadRecoveryService } from "../services/file-upload-recovery.service";
import { FileUploadService } from "../services/file-upload.service";
import { GoogleDriverService } from "../services/google-driver.service";
import { HelperService } from "../services/helper.service";
import { HttpClient } from "../services/http-client";
import { LightHttp } from "../services/light-http.service";
import { LogService } from "../services/log.service";
import { LoginService } from "../services/login.service";
import { MarkdownService } from "../services/markdown.service";
import { MemeUploadService } from "../services/meme-upload.service";
import { MetadataService } from "../services/metadata.service";
import { MotivesService } from "../services/motives.service";
import { OfflineTaskService } from "../services/offline-task.service";
import { PageDataProviderService } from "../services/page-data-provider.service";
import { PaymentService } from "../services/payments.service";
import { ProcessCompleteCheckService } from "../services/process-complete-check.service";
import { ProcessorResolverService } from "../services/processor-resolver.service";
import { ScriptLoadService } from "../services/script-load.service";
import { SettingsService } from "../services/settings.service";
import { SocketJSService } from "../services/socketjs.service";
import { SpinnerService } from "../services/spinner.service";
import { StorageService } from "../services/storage.service";
import { ThumbnailService } from "../services/thumbnail.service";
import { ToastService } from "../services/toast.service";
import { UIContext } from "../services/ui-context";
import { UploadedFilesService } from "../services/uploaded-files.service";
import { UserPreferenceService } from "../services/user-preference.service";
import { UserTraceService } from "../services/user-trace.service";
import { WebSocketService } from "../services/websocket.service";
import { WindowService } from "../services/window.service";
import { WorkflowRecreateService } from "../services/workflow-recreate.service";
import { ApiKeysService } from "../services/api-keys.service";
import { WebhooksService } from "../services/webhooks.service";
import { ConversionHistoryService } from "../services/conversion-history.service";
import { BillingService } from "../services/billing.service";
import { AdminBillingService } from "../services/admin-billing.service";
import { BulkZipService } from "../services/bulk-zip.service";
import { EnforcementErrorService } from "../services/enforcement-error.service";
import { ProactiveRefreshScheduler } from "../services/proactive-refresh.scheduler";
import { RefreshService } from "../services/refresh.service";
import { StepUpService } from "../services/step-up.service";
import { CrossTabAuthService } from "../services/cross-tab-auth.service";
import { DevicesService } from "../services/devices.service";
import { IOC_TYPES } from './ioc.types';

// `container` + `lazyInject` are defined in ./container and re-exported below so
// that BOUND services (e.g. LoginService) can import `lazyInject` from
// ./container without a circular import back through this bindings file.
export { container, lazyInject };

// container.bind(EnvironmentService).to(EnvironmentService).inSingletonScope();
container.bind(EnvironmentService).to(EnvironmentService).inSingletonScope();
container.bind(ApiConfig).to(ApiConfig).inSingletonScope();
container.bind(DOMStorage).to(DOMStorage).inSingletonScope();
container.bind(LightHttp).to(LightHttp).inSingletonScope();
container.bind(HttpClient).to(HttpClient).inSingletonScope();

container.bind(OfflineTaskService).to(OfflineTaskService).inSingletonScope();
container.bind(StorageService).to(StorageService).inSingletonScope();
container.bind(WebSocketService).to(WebSocketService).inSingletonScope();
container.bind(SettingsService).to(SettingsService).inSingletonScope();
container.bind(LoginService).to(LoginService).inSingletonScope();
container.bind(WindowService).to(WindowService).inSingletonScope();
container.bind(UIContext).to(UIContext).inSingletonScope();
container.bind(ProcessCompleteCheckService).to(ProcessCompleteCheckService).inSingletonScope();
container.bind(MotivesService).to(MotivesService).inSingletonScope();
container.bind(AuthService).to(AuthService).inSingletonScope();
container.bind(ScriptLoadService).to(ScriptLoadService).inSingletonScope();
container.bind(PageDataProviderService).to(PageDataProviderService).inSingletonScope();
container.bind(GAService).to(GAService).inSingletonScope();
container.bind(GoogleDriverService).to(GoogleDriverService).inSingletonScope();
container.bind(DropboxService).to(DropboxService).inSingletonScope();
container.bind(SpinnerService).to(SpinnerService).inSingletonScope();
container.bind(FileUploadService).to(FileUploadService).inSingletonScope();
container.bind(HelperService).to(HelperService).inSingletonScope();
container.bind(FileUploadRecoveryService).to(FileUploadRecoveryService).inSingletonScope();
container.bind(FileManagerService).to(FileManagerService).inSingletonScope();
container.bind(ConnectivityService).to(ConnectivityService).inSingletonScope();
container.bind(ProcessorResolverService).to(ProcessorResolverService).inSingletonScope();
container.bind(UploadedFilesService).to(UploadedFilesService).inSingletonScope();
container.bind(FileProcessService).to(FileProcessService).inSingletonScope();
container.bind(ToastService).to(ToastService).inSingletonScope();
container.bind(MetadataService).to(MetadataService).inSingletonScope();
container.bind(MarkdownService).to(MarkdownService).inSingletonScope();
container.bind(ThumbnailService).to(ThumbnailService).inSingletonScope();
container.bind(FileDownloadService).to(FileDownloadService).inSingletonScope();
container.bind(PaymentService).to(PaymentService).inSingletonScope();
container.bind(UserPreferenceService).to(UserPreferenceService).inSingletonScope();
container.bind(MemeUploadService).to(MemeUploadService).inSingletonScope();
container.bind(FileShareService).to(FileShareService).inSingletonScope();
container.bind(LogService).to(LogService).inSingletonScope();
container.bind(FileInputButtonService).to(FileInputButtonService).inSingletonScope();
container.bind(SocketJSService).to(SocketJSService).inSingletonScope();
container.bind(UserTraceService).to(UserTraceService).inSingletonScope();
container.bind(WorkflowRecreateService).to(WorkflowRecreateService).inSingletonScope();
container.bind(ApiKeysService).to(ApiKeysService).inSingletonScope();
container.bind(WebhooksService).to(WebhooksService).inSingletonScope();
container.bind(ConversionHistoryService).to(ConversionHistoryService).inSingletonScope();
container.bind(BillingService).to(BillingService).inSingletonScope();
container.bind(AdminBillingService).to(AdminBillingService).inSingletonScope();
container.bind(BulkZipService).to(BulkZipService).inSingletonScope();
container.bind(EnforcementErrorService).to(EnforcementErrorService).inSingletonScope();
container.bind(ProactiveRefreshScheduler).to(ProactiveRefreshScheduler).inSingletonScope();
container.bind(RefreshService).to(RefreshService).inSingletonScope();
container.bind(StepUpService).to(StepUpService).inSingletonScope();
container.bind(CrossTabAuthService).to(CrossTabAuthService).inSingletonScope();
container.bind(DevicesService).to(DevicesService).inSingletonScope();
